import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import {
  CarouselContainer,
  CarouselImage,
  NavigationButton,
  IndicatorsContainer,
  Indicator,
  CarouselWrapper,
  CarouselSlide,
} from './styled.js';
import { ArrowBack, ArrowForward } from '@mui/icons-material';
import { resolveImageUrl } from 'utils/apiOrigin.js';

const ImageCarousel = ({ images }) => {
  const [currentIndex, setCurrentIndex] = useState(0);

  useEffect(() => {
    setCurrentIndex(0);
  }, [images]);

  const prevSlide = () => {
    setCurrentIndex((prev) => (prev === 0 ? images.length - 1 : prev - 1));
  };

  const nextSlide = () => {
    setCurrentIndex((prev) => (prev === images.length - 1 ? 0 : prev + 1));
  };

  if (!images || images.length === 0) return null;

  return (
    <>
      <CarouselContainer>
        <CarouselWrapper $currentIndex={currentIndex}>
          {images.map((url, index) => (
            <CarouselSlide key={crypto.randomUUID()}>
              <CarouselImage src={resolveImageUrl(url)} alt={`Imagem ${index + 1}`} />
            </CarouselSlide>
          ))}
        </CarouselWrapper>

        {images.length > 1 && (
          <>
            <NavigationButton $position="left" onClick={prevSlide}>
              <ArrowBack sx={{ fontSize: '50px' }} />
            </NavigationButton>
            <NavigationButton $position="right" onClick={nextSlide}>
              <ArrowForward sx={{ fontSize: '50px' }} />
            </NavigationButton>
          </>
        )}
      </CarouselContainer>

      {images.length > 1 && (
        <IndicatorsContainer>
          {images.map((_, index) => (
            <Indicator
              key={crypto.randomUUID()}
              $active={index === currentIndex}
              onClick={() => setCurrentIndex(index)}
            />
          ))}
        </IndicatorsContainer>
      )}
    </>
  );
};

ImageCarousel.propTypes = {
  images: PropTypes.arrayOf(PropTypes.string).isRequired,
};

export default ImageCarousel;
